import React, { useContext } from "react";
import ProgressIndicator from "../common/ProgressIndicator";
import { GameContext } from "../../context/GameContext";

const MobileResult = () => {
  const { userAnswer, questionsArray, restartGame } = useContext(GameContext);

  return (
    <main className="result_container">
      <div className="result_content">
        <p className="result_text-xl">
          Resultat: {userAnswer.length} rätt
          <span className="result_text-sm"> av {questionsArray.length}</span>
        </p>
        <ProgressIndicator />
      </div>
      <button className="restart_button" onClick={restartGame}>
        Spela igen
      </button>
    </main>
  );
};

export default MobileResult;
